/*
  Page content written for the old theme, shown in the standard and policy page templates ([data-page-body]).
  The words are never changed; this only fixes structure the old theme's CSS used to handle:
  - The old title banner (.hero-bg: a stock photo and an H2 repeating the page title) is removed.
  - Old radio-button "tabs" (FAQ) become native <details> accordions.
  - Headings get ids, and an "On this page" list is built into [data-page-toc] when there are three or more.
*/
const body = document.querySelector('[data-page-body]');

if (body) {
  body.querySelectorAll('.hero-bg').forEach((el) => el.remove());

  // FAQ: <div class="tab"><input type="radio"><label class="tab-label">Q</label><div class="tab-content">A</div></div>
  body.querySelectorAll('.tab').forEach((tab) => {
    const label = tab.querySelector('.tab-label, label');
    const content = tab.querySelector('.tab-content');
    if (!label || !content) return;
    const details = document.createElement('details');
    details.className = 'page-faq';
    const summary = document.createElement('summary');
    summary.innerHTML = label.innerHTML;
    const answer = document.createElement('div');
    answer.className = 'page-faq-answer';
    answer.append(...content.childNodes);
    details.append(summary, answer);
    tab.replaceWith(details);
  });
  body.querySelectorAll('input[type="radio"]').forEach((input) => input.remove());

  const toc = document.querySelector('[data-page-toc]');
  const headings = [...body.querySelectorAll('h2, h3')].filter((h) => h.textContent.trim());
  const used = new Set();
  headings.forEach((h) => {
    let id = h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
    while (used.has(id) || document.getElementById(id)) id += '-2';
    used.add(id);
    h.id = h.id || id;
  });
  if (toc && headings.length >= 3) {
    const list = toc.querySelector('ol');
    headings.forEach((h) => {
      const li = document.createElement('li');
      if (h.tagName === 'H3') li.className = 'page-toc-sub';
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      // Many old policy headings are in capitals: show them in sentence case in the list only.
      const text = h.textContent.trim().replace(/\s+/g, ' ');
      a.textContent = text === text.toUpperCase() ? text.charAt(0) + text.slice(1).toLowerCase() : text;
      li.append(a);
      list.append(li);
    });
    toc.hidden = false;

    // Mark the section in view
    const links = new Map([...list.querySelectorAll('a')].map((a) => [a.hash.slice(1), a]));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((a) => a.removeAttribute('aria-current'));
          links.get(entry.target.id)?.setAttribute('aria-current', 'true');
        });
      },
      { rootMargin: '0px 0px -75% 0px' }
    );
    headings.forEach((h) => observer.observe(h));
  }
}
